<template>
<div>
  <div class="hxq_subpage">
    <Header/>
    <Navigationzj :toptNavi="8"/>
    <div class="zmpp_con w1200" style="text-align:center;">
      <div style="margin-top:60px;width:100%;display: inline-block;">
        <el-col :xs="24" :sm="24" :lg="12">
          <div class="chart-title"><i class="el-icon-tickets"></i><span>销量查看</span></div>
          <div class="chart-wrapper" style="background-color: transparent;">
            <div class="line" id="line" :style="{width: '100%', height: '300px'}"></div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :lg="5">
          <div class="chart-title" style="padding:22px"></div>
          <div class="chart-wrapper" style="background-color: transparent;">
            <div class="line" id="line" :style="{width: '95%', height: '300px'}">
              <el-card class="box-card">
                <div slot="header" class="clearfix">
                  <div style="text-align: left;padding-bottom:13px">
                    <span style="width: 100%;font-size: 25px; "><count-to :start-val="0" :end-val="total" :duration="2600" class="card-panel-num"/>件</span>
                  </div>
                  <div>
                    <span style="float: left; padding: 3px 0,width: 100%" type="text"><count-to :start-val="0" :end-val="monthtotal" :duration="2600" class="card-panel-num"/>件（本月）</span>
                  </div>
                </div>
                <div class="text item">
                  <div style="width: 50%;height:20px;float:left;text-align: left;"><div class="itemchild" style="background-color:#fbbd08;"></div>所有的订单</div>
                  <div style="width: 50%;height:20px;float:left;text-align: right;">
                    <span><count-to :start-val="0" :end-val="allorder_total" :duration="2600" class="card-panel-num"/>件</span>
                  </div>
                </div>
                <div class="text item">
                  <div style="width: 50%;height:20px;float:left;text-align: left;"><div class="itemchild" style="background-color:#e54d42;"></div>未发货订单</div>
                  <div style="width: 50%;height:20px;float:left;text-align: right;">
                    <span><count-to :start-val="0" :end-val="noshiporder_total" :duration="2600" class="card-panel-num"/>件</span>
                  </div>
                </div>
                <div class="text item">
                  <div style="width: 50%;height:20px;float:left;text-align: left;"><div class="itemchild" style="background-color:#39b54a;"></div>已结账订单</div>
                  <div style="width: 50%;height:20px;float:left;text-align: right;">
                    <span><count-to :start-val="0" :end-val="closeorder_total" :duration="2600" class="card-panel-num"/>件</span>
                  </div>
                </div>
                <div class="text item">
                  <div style="width: 50%;height:20px;float:left;text-align: left;"><div class="itemchild" style="background-color:#0081ff;"></div>已收货订单</div>
                  <div style="width: 50%;height:20px;float:left;text-align: right;">
                    <span><count-to :start-val="0" :end-val="recegoodorder_total" :duration="2600" class="card-panel-num"/>件</span>
                  </div>
                </div>
              </el-card>
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :lg="7">
          <div class="chart-title" style="padding:22px"></div>
          <div class="chart-wrapper" style="background-color: transparent;height:300px" >
            <el-calendar>
              <template
                slot="dateCell"
                slot-scope="{data}">
                <p :class="data.isSelected ? 'is-selected' : ''" @click="selectdate(data)">
                  {{ data.day.split('-').slice(2).join('-') }}{{ data.isSelected ? '✔️' : ''}}
                </p>
              </template>
            </el-calendar>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :lg="6">
          <div class="chart-title"><i class="el-icon-time"></i><span>服务类型</span></div>
          <div class="chart-wrapper" style="background-color: transparent;">
            <div class="pie" id="pie" :style="{width: '100%', height: '300px'}"></div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :lg="11">
          <div class="chart-title"><i class="el-icon-s-data"></i><span>商品类别</span></div>
          <div class="chart-wrapper" style="background-color: transparent;">
            <div class="bar" id="bar" :style="{width: '100%', height: '300px'}"></div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :lg="7">
          <div class="chart-title"><i class="el-icon-s-opportunity"></i><span>合作单位</span></div>
          <div class="chart-wrapper" style="background-color: transparent;">
            <div id="box">
              <ul id="con1" ref="con1" :class="{anim:animate==true}">
                <li v-for="(item,index) in jointList" :key="index">{{item.name}}<span style="padding-left:50%;">{{item.create_time.substring(0,10)}}</span></li>
              </ul>
            </div>
          </div>
        </el-col>
      </div>
    </div>
  </div>
  <Footer/>
</div>
</template>
<script>
import api from '@/api/statistics'
import Header from '@/components/Header'
import Navigationzj from '@/components/Navigationzj'
import Footer from '@/components/Footer'
import CountTo from 'vue-count-to'

export default {
  name: 'Statistics',
  components: {
    Header,
    Navigationzj,
    Footer,
    CountTo
  },
  data () {
    return {
      animate: false,
      jointList: [],
      presets: [],
      months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
      type: 'line',
      allorder: [],
      noshiporder: [],
      closeorder: [],
      recegoodorder: [],
      total: 0,
      monthtotal: 0,
      allorder_total: 0,
      noshiporder_total: 0,
      closeorder_total: 0,
      recegoodorder_total: 0,
      category_title: [],
      category_number: [],
      myChartline: null,
      myChartpie: null,
      myChartbar: null,
      serve: [],
      servedata: [],
      color: ['#6739b6', '#8dc63f', '#f37b1d', '#1cbbb4'],
      datas: {}
    }
  },
  watch: {
    allorder: {
      handler (newValue, oldValue) {
        if (newValue) {
          this.allorder = newValue
        } else {
          this.allorder = oldValue
        }
        this.drawLine()
      }
    }
  },
  created () {
    setInterval(this.scroll, 1000)
  },
  mounted () {
    this.getstatistics()
  },
  methods: {
    selectdate (values) {
      var data = {
        create_time: values.day
      }
      this.getstatistics(data)
    },
    getstatistics (data) {
      this.reset()
      api.getstatistics(data).then(res => {
        if (data) {
          this.months = [data.create_time]
          this.type = 'bar'
        } else {
          this.months = ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
          this.type = 'bar'
        }
        // 所有订单
        for (var i = 0; i < res.items.allorder.length; i++) {
          this.allorder.push(res.items.allorder[i]['count'])
        }
        // 未发货订单
        for (var j = 0; j < res.items.noshiporder.length; j++) {
          this.noshiporder.push(res.items.noshiporder[j]['count'])
        }
        // 已结账订单
        for (var k = 0; k < res.items.closeorder.length; k++) {
          this.closeorder.push(res.items.closeorder[k]['count'])
        }
        // 已收获订单
        for (var l = 0; l < res.items.recegoodorder.length; l++) {
          this.recegoodorder.push(res.items.recegoodorder[l]['count'])
        }
        // 总件数
        this.total = res.items.total
        // 本月总件数
        this.monthtotal = res.items.monthtotal
        // 所有的订单件数
        this.allorder_total = res.items.allorder_total
        // 未发货订单件数
        this.noshiporder_total = res.items.noshiporder_total
        // 已结账订单件数
        this.closeorder_total = res.items.closeorder_total
        // 已收货订单件数
        this.recegoodorder_total = res.items.recegoodorder_total
        // 服务类型
        for (var m = 0; m < res.items.serve.length; m++) {
          this.serve.push(res.items.serve[m]['title'])
          this.datas = {
            value: res.items.serve[m]['count'],
            itemStyle: {
              color: this.color[m]
            }
          }
          this.servedata.push(this.datas)
        }
        // 商品类别
        for (var n = 0; n < res.items.category.length; n++) {
          this.category_title.push(res.items.category[n]['title'])
          this.category_number.push(res.items.category[n]['number'])
        }
        // 通知公告
        this.jointList = res.items.joint
      })
    },
    scroll () {
      this.animate = true
      setTimeout(() => {
        this.jointList.push(this.jointList[0])
        this.jointList.shift()
        this.animate = false
      }, 500)
    },
    reset () {
      this.allorder = []
      this.noshiporder = []
      this.closeorder = []
      this.recegoodorder = []
      this.category_title = []
      this.category_number = []
      this.serve = []
      this.datas = {}
      this.servedata = []
    },
    drawLine () {
      // 订单查看
      if (this.myChartline !== null && this.myChartline !== '' && this.myChartline !== undefined) {
        this.myChartline.dispose()
      }
      this.myChartline = this.$echarts.init(document.getElementById('line'))
      this.myChartline.setOption({
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          type: 'category',
          data: this.months
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '所有的订单',
            data: this.allorder,
            type: this.type,
            smooth: true,
            color: '#fbbd08'
          },
          {
            name: '未发货订单',
            data: this.noshiporder,
            type: this.type,
            smooth: true,
            color: '#e54d42'
          },
          {
            name: '已结账订单',
            data: this.closeorder,
            type: this.type,
            smooth: true,
            color: '#39b54a'
          },
          {
            name: '已收货订单',
            data: this.recegoodorder,
            type: this.type,
            smooth: true,
            color: '#0081ff'
          }
        ]
      })
      // 服务分类
      if (this.myChartpie !== null && this.myChartpie !== '' && this.myChartpie !== undefined) {
        this.myChartpie.dispose()
      }
      this.myChartpie = this.$echarts.init(document.getElementById('pie'))
      this.myChartpie.setOption({
        polar: {
          radius: [50, '80%']
        },
        angleAxis: {
          max: 100,
          startAngle: 90
        },
        radiusAxis: {
          type: 'category',
          data: this.serve
        },
        tooltip: {},
        series: {
          type: 'bar',
          data: this.servedata,
          coordinateSystem: 'polar',
          label: {
            show: true,
            position: 'middle',
            formatter: '{b}: {c}'
          }
        }
      })
      // 商品类别
      if (this.myChartbar !== null && this.myChartbar !== '' && this.myChartbar !== undefined) {
        this.myChartbar.dispose()
      }
      this.myChartbar = this.$echarts.init(document.getElementById('bar'))
      this.myChartbar.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        xAxis: {
          type: 'category',
          data: this.category_title
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            barWidth: '20%',
            data: this.category_number,
            type: 'bar'
          }
        ]
      })
    }
  }
}
</script>
<style scoped>
.chart-title{
  /* background: #fff;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1); */
  margin-bottom: 10px;
  padding: 15px 20px;
  font-weight: 400;
  font-size: 14px;
  text-align: left;
}
#box{
  width: 100%;
  height: 300px;
  overflow: hidden;
  padding-left: 30px;
}
.anim{
  transition: all 0.5s;
  margin-top: -30px;
}
#con1 li{
  list-style: none;
  line-height: 30px;
  height: 30px;
  text-align: left;
}
.text {
  font-size: 14px;
}
.item {
  height: 20px;
  margin-bottom: 18px;
  border-bottom: 1px solid #EBEEF5;
}
.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both
}
.box-card {
  width: 100%;
  height: 285px;
}
.el-icon-tickets {
  color: #ff9933;
}
.el-icon-time {
  color: #33cc33;
}
.el-icon-s-data {
  color: #436aa6;
}
.el-icon-s-opportunity {
  color: #ff6666;
}
.itemchild {
  float: left;
  width: 5px;
  height: 24px;
  margin-top: -4px;
  margin-right: 5px;
}
</style>
<style>
.el-calendar-table .el-calendar-day {
  height: 25px;
}
.el-card__header {
  background-color: #436aa6;
  color: #fff;
}
.is-selected {
  color: #1989FA;
}
</style>



// WEBPACK FOOTER //
// src/view/statistics/statistics.vue